import React from "react"
import { LinkButton } from './LinkButton'
import Image from "next/image"

export const CtaButton = () => {
  return (
    <LinkButton
      variant="new-blue"
      customPadding="p-4"
      className="!rounded-10 !font-inter grid"
      href="https://api.whatsapp.com/send?phone=6281312117711"
    >
      <div className="flex items-center gap-3">
        <Image
          src="/landing/landing_banner-button.webp"
          width={48}
          height={48}
          alt="career-consultant"
          className="rounded"
        />
        <span>
          Konsultasi dengan Putri <br />{" "}
          <span className="text-sm font-normal">(Karir Konsultan, bukan team Sales)</span>
        </span>
      </div>
    </LinkButton>
  )
}
